import styled from "styled-components";
import { RowFlex } from "@/main/components/shared/styles";
import { ListButtons } from "./buttonStatus/styles";

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	border: 1px solid #ccc;
	border-radius: 8px;
	padding: 0.4rem 1rem 0.8rem;
	margin: 0 0 0.4rem 0;
	gap: 0.2rem;
`;

export const Header = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: center;
	gap: 0.6rem;

	> h4 {
		margin: 0;
	}

	@media (max-width: 740px) {
		flex-direction: column;

		> ${ListButtons} {
			margin: 0 auto;
			width: 100%;
			> div {
				width: 100%;
			}
		}
	}

	@media (max-width: 425px) {
		flex-direction: row;
		flex-wrap: wrap;
		align-items: center;
	}
`;

export const SupplierName = styled.h4`
	width: fit-content;
	max-width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;

	@media (max-width: ${({ theme }) => theme.breakpoints.desktopLarge}) {
		max-width: 350px;
	}
	@media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
		max-width: 400px;
	}
	@media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
		max-width: 300px;
	}
	@media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
		max-width: 200px;
	}
`;

export const AreaInfoHeader = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;

	gap: 0.6rem;
	flex: 1;
`;

const PaddingDefault = styled.div`
	padding: 0 1rem;

	@media (max-width: 740px) {
		padding: 0;
	}
`;

export const Content = styled(PaddingDefault)`
	padding: 0;
`;
export const Footer = styled(PaddingDefault)`
	padding: 0.4rem 1rem 0;
`;
interface IAreaContactSupplierProps {
	$showInMobile?: boolean;
}
export const AreaContactSupplier = styled(RowFlex)<IAreaContactSupplierProps>`
	width: auto;

	@media (max-width: ${({ theme }) => theme.breakpoints.desktopSmall}) {
		display: ${({ $showInMobile }) => ($showInMobile ? "flex" : "none")};
		flex-wrap: wrap;
		gap: 0.2rem;
	}
`;

export const LinkEvaluate = styled.span`
	text-decoration: underline;
	cursor: pointer;
	color: ${({ theme }) => theme.pantone2727C};
	font-size: 15px;
`;

export const ContainerRightHeader = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	align-items: center;
	gap: 2rem;
	margin-left: auto;

	@media (max-width: 740px) {
		margin-left: 0;
	}
`;

export const ContainerEvaluate = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const AreaInfoContactSupplierMobile = styled.div`
	display: none;

	@media (max-width: ${({ theme }) => theme.breakpoints.desktopSmall}) {
		display: flex;
		flex-wrap: wrap;
		gap: 0.2rem;
	}
`;

export const AreaEmail = styled.div`
	display: flex;
	flex-direction: row;
`;
export const TextCollumnLabel = styled.span`
	width: fit-content;
	max-width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;

	@media (max-width: ${({ theme }) => theme.breakpoints.desktopLarge}) {
		max-width: 120px;
	}
	@media (max-width: ${({ theme }) => theme.breakpoints.desktopSmall}) {
		max-width: 300px;
	}
`;
